export default "__VITE_ASSET__Bd4ZvN$c__"